import { Circle } from "lucide-react";
import { formatDateTime, formatDuration, formatMoney, formatNumber, statusText } from "./usageFormatters";

function tone(status) {
    if (status === "success") return "bg-emerald-50 text-emerald-700";
    if (status === "in_progress") return "bg-blue-50 text-blue-700";
    return "bg-red-50 text-red-700";
}

export default function RecentActivity({ items = [] }) {
    return (
        <section className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
                <div><h2 className="font-semibold text-slate-900">Actividad reciente</h2><p className="mt-0.5 text-xs text-slate-500">Se actualiza automáticamente cada 5 segundos.</p></div>
                <div className="flex items-center gap-1.5 text-xs font-medium text-emerald-600"><Circle className="h-2.5 w-2.5 fill-emerald-500" /> EN VIVO</div>
            </div>
            <div className="max-h-[430px] overflow-auto">
                {items.map((item) => (
                    <div key={item.request_id} className="grid gap-2 border-b border-slate-100 px-5 py-3 text-sm last:border-0 sm:grid-cols-[1.2fr_1.2fr_1fr_auto] sm:items-center">
                        <div><p className="font-medium text-slate-900">{item.application_name}</p><p className="text-xs text-slate-400">{item.feature || "Sin etiqueta"} · {formatDateTime(item.started_at)}</p></div>
                        <div><p className="text-slate-700">{item.actual_model || item.requested_model}</p><p className="text-xs text-slate-400">{formatNumber(item.total_tokens)} tokens · {formatDuration(item.duration_ms)}</p></div>
                        <div><span className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${tone(item.status)}`}>{statusText(item.status)}</span>{item.error_type && <span className="ml-2 text-xs text-red-500">{item.error_type}</span>}</div>
                        <div className="text-right font-medium tabular-nums text-slate-700">{formatMoney(item.estimated_cost_usd)}</div>
                    </div>
                ))}
                {!items.length && <div className="px-5 py-12 text-center text-sm text-slate-400">Todavía no hay requests registrados.</div>}
            </div>
        </section>
    );
}
